<div class="logout-container" fxLayout="column" fxLayoutAlign="center center" *ngIf="loaded">
  <mat-card>
    <mat-card-content class="content">
      <img src="../../../assets/images/logo-solocal.svg" alt="logo" class="logo" />
      <h2 *ngIf="state == 'logout'">{{ 'Logout successful!' | translate}}</h2>
      <h2 *ngIf="state == 'expired'">{{ 'Expired session' | translate}}</h2>
      <button mat-raised-button color="primary" *ngIf="!isSSO" (click)="redirectNow()">{{ 'Reconnect' | translate}}</button>
    </mat-card-content>
  </mat-card>
</div>
